import React, { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Table, Button, Pagination, Input } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import CreateClosures from './CreateClosures';
import ClosureDetailsModal from './ClosureDetailsModal';

import { getTodaysDate, formatToTwoDecimals } from '../../../utilities/utils';
import { getClosures } from '../../../services/ClosureService';
const FORM_TYPES = ['CLSR_ADV_AUTH', 'CLSR_EPCG', 'CLSR_BOND'];
const EXCEL_TYPES = ['CLSR_DRAWBACK', 'CLSR_RODTEP'];
const { Search } = Input;


const Closures = () => {
    const [selectedCardType, setSelectedCardType] = useState('CLSR_DRAWBACK');
    const [jsonData, setJsonData] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const iec_no = localStorage.getItem('iec_no');
    const username = localStorage.getItem('name');
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedIEC, setSelectedIEC] = useState(localStorage.getItem('iec_no'));
    const [modalData, setModalData] = useState({});
    const [iecName, setIECName] = useState(localStorage.getItem('name'));
    const [userRole, setUserRole] = useState(localStorage.getItem('role'))
    const [filteredValues, setFilteredValues] = useState([]); // State for filtered users
    const [searchText, setSearchText] = useState("");

    const MAX_PAGE_SIZE = 20;

    const today = new Date();
    // Extract day, month, and year components
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = today.getFullYear();
    // Concatenate components with hyphens
    const formattedDate = `${day}-${month}-${year}`;

    const columnNames = [
        {
            header: 'SRN',
            title: 'SRN',
            dataIndex: 'index',
            key: 'index',
            width: 70,
            render: (text, record, index) => index + 1,
        },
        {
          title: 'Details',
          dataIndex: 'details',
          key: 'details',
          width: 120,
          render: (_, record) => {
            
            return(<Button
              //style={{ backgroundColor: isDisabled ? 'lightgrey' : '#7CA37C' }}
               onClick={() => viewClosureDetails(record)}>
              View Details
            </Button>)
            
          },
        },
        {
            header: 'IEC No',
            title: 'IEC No',
            dataIndex: 'iec_no',
            key: 'iec_no',
            width: 120,
        },
        {
          header: 'IEC Name',
          title: 'IEC Name',
          dataIndex: 'client_name',
          key: 'client_name',
          width: 250,
        },
        {
            header: 'File Name',
            title: 'File Name',
            dataIndex: 'filename',
            key: 'filename',
            width: 320,
            render: (filename, record) => {
                return filename?.split('_')[2];
            }
        },
        {
            header: 'File Status',
            title: 'File Status',
            dataIndex: 'file_status',
            key: 'file_status',
            width: 120,
        },
        {
            header: 'Remark',
            title: 'Remark',
            dataIndex: 'file_remark',
            key: 'file_remark',
            width: 150,
        },
    ]

    const columnNamesWithLicenseDetails = [
      {
          header: 'SRN',
          title: 'Sr. No.',
          dataIndex: 'index',
          key: 'index',
          width: 70,
          render: (text, record, index) => index + 1,
      },
      {
        title: 'Details',
        dataIndex: 'details',
        key: 'details',
        width: 120,
        render: (_, record) => {
          
          return(<Button
            //style={{ backgroundColor: isDisabled ? 'lightgrey' : '#7CA37C' }}
             onClick={() => viewClosureDetails(record)}>
            View Details
          </Button>)
          
        },
      },
      {
          header: 'IEC No',
          title: 'IEC NO',
          dataIndex: 'iec_no',
          key: 'iec_no',
          width: 120,
      },
      {
        header: 'IEC Name',
        title: 'IEC Name',
        dataIndex: 'client_name',
        key: 'client_name',
        width: 250,
      },
      {
          header: 'License No',
          title: 'License No',
          dataIndex: 'license_no',
          key: 'license_no',
          width: 180,
      },
      {
          header: 'Status',
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          width: 120,
      },
      {
          header: 'Remark',
          title: 'Remark',
          dataIndex: 'remark',
          key: 'remark',
          width: 150,
      },
  ]


    const viewClosureDetails = (record) => {
      console.log(record);
      setIsModalVisible(true);
      setModalData(record);
    }

    const location = useLocation();

    const getAllClosures = async (page, cardType) => {
        try{
            const response = await getClosures(iec_no, cardType, page, MAX_PAGE_SIZE);

            if(response){
                console.log("response", response);
                setJsonData([]);
                setJsonData(response.closures);
                setFilteredValues(response.closures);
                setTotalPages(response.total_count);
            }
            else{
                console.log("Null response")
            }
        }
        catch(error){
            console.log(error);
        }
    }

    const handleSearch = (value) => {
      setSearchText(value);
      if (!value) {
        setFilteredValues(jsonData);
        return;
      }
      const lowercasedValue = value.toLowerCase();
      const filteredData = jsonData.filter((user) =>
        ["license_no", "iec_no", "status", "remark", "client_name"].some((key) =>
          user[key] && String(user[key]).toLowerCase().includes(lowercasedValue)
        )
      );  
      setFilteredValues(filteredData);
    };

    const onPageChange = (page) => {
        console.log(page);
        setCurrentPage(page);
        getAllClosures(page, selectedCardType);
      };

    useEffect(() => {
        console.log("location: ", location)
        const params = new URLSearchParams(location.search);
        const cardTypeFromURL = params.get('__card__');

        if (cardTypeFromURL) {
            setSelectedCardType(cardTypeFromURL);
            const page = 1;
            getAllClosures(page, cardTypeFromURL);
            if (FORM_TYPES.includes(cardTypeFromURL)){
              setTableColumns(columnNamesWithLicenseDetails)
            }
            if (EXCEL_TYPES.includes(cardTypeFromURL)){
                setTableColumns(columnNames);
            }
        } else {
            setSelectedCardType(''); // Default selected card type
        }


       
    }, [location.search]);

    return (
      <Fragment>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Closure - {selectedCardType.replace(/CLSR_/g, "").replace(/_/g, " ")}</h4>  
                </div>
                <div>
                
                  <button onClick={() => setModalVisible(true)}
                  className='btn btn-primary'
                  >
                    Create +
                  </button>
                </div>
              </Card.Header>
              <Card.Body className="px-0">
              {FORM_TYPES.includes(selectedCardType) && (
                  <Search
                    placeholder="Search"
                    allowClear
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{ width: 250, marginLeft: 15, marginBottom: 15}}
                  />
                )}
                <CreateClosures
                  visible={modalVisible}
                  type_name={selectedCardType}
                  onClose={() => setModalVisible(false)}
                  iecNo={selectedIEC}
                  onSubmit={() => getAllClosures(1, new URLSearchParams(location.search).get('__card__'))}
                />

                <ClosureDetailsModal
                    visible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    closureId={modalData.closure_id} // The closure ID
                    closureType={modalData.type_name} // The closure type
                    iec={modalData.iec_no}
                    onDelete={(id) => getAllClosures(1, new URLSearchParams(location.search).get('__card__'))}
                />
              
                <div className="table-responsive">
                  <Table bordered columns={tableColumns} dataSource={filteredValues} loading={isLoading} pagination={false} scroll={{ x: 'max-content' }}/>
                  <br />
                  <Pagination current={currentPage} defaultPageSize={MAX_PAGE_SIZE} total={totalPages} onChange={onPageChange} align="end" />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Fragment>
    );

}


export default Closures;